import { Stack } from '@mantine/core'
import { useNavigate } from 'react-router-dom'
import AllLocationsAdConfiguration from '../components/location/AllLocationsAdConfiguration'

const ConfigureAllLocationsAdPage = () => {
  const navigate = useNavigate()

  return (
    <Stack maw={860} mx='auto' w='100%' p={{ base: 'md', sm: 'xl' }} pb={100} mih='calc(100vh - 80px)'>
      <AllLocationsAdConfiguration
        onCompletion={() => navigate('/cart')}
        onCancel={() => navigate(-1)}
      />
    </Stack>
  )
}

export default ConfigureAllLocationsAdPage
